var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 20.6146L17.1794 16.3077H14.8717L13.3333 14.7692L16.4102 10.1538H21.7948M7.94864 6.30769L9.58032 7.93937C10.4571 8.81614 10.727 10.1311 10.2665 11.2823V11.2823C9.79576 12.4591 8.656 13.2308 7.38855 13.2308H4.10248M23.3333 14C23.3333 19.5228 18.8561 24 13.3333 24C7.8104 24 3.33325 19.5228 3.33325 14C3.33325 8.47715 7.8104 4 13.3333 4C18.8561 4 23.3333 8.47715 23.3333 14Z",
    stroke: "#065EEA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.4488c02fe7f68f12502c25013f4312e7.svg";
export { ForwardRef as ReactComponent };